@if ({
  filterOptions: filterOptionsSelector ? (filterOptionsSelector | select:[]) : [],
  noPaginationData: !(paginationSelectors.hasData | select)
}; as vm) {
  @if (routerSelectors.hasQueryParamValue(queryParamName) | select) {
    @if (isMultiSelect && filterOptionsSelector) {
      <button mat-flat-button color="surface4" [matMenuTriggerFor]="filterMenu" [matMenuTriggerData]="{ showHeader: true }" class="text-nowrap">
        <ng-container *ngTemplateOutlet="buttonLabel; context: {selector: filterOptionsSelector}"/>
        <ng-container *ngTemplateOutlet="closeIcon"/>
      </button>
    } @else {
      <button mat-flat-button color="surface4" (click)="onClickActiveFilterButton()" class="text-nowrap">
        @if (filterOptionsSelector) {
          <ng-container *ngTemplateOutlet="buttonLabel; context: {selector: filterOptionsSelector}"/>
        } @else {
          {{ routerSelectors.queryParamValue(queryParamName) | select | format:'DATE_ONLY_RANGE' }}
        }

        <ng-container *ngTemplateOutlet="closeIcon"/>
      </button>
    }

    <ng-template #buttonLabel let-selector="selector">
      {{ routerSelectors.queryParamValueAsDisplayValue(queryParamName, selector) | select:'' }}
    </ng-template>

    <ng-template #closeIcon>
      <mat-icon class="mat-icon-size-4.5 material-icons-outlined text-on-surface-variant -me-2 -mb-[0.21875rem]"
                (click)="onClickActiveFilterCloseIcon($event)">
        clear
      </mat-icon>
    </ng-template>
  } @else {
    @switch (filterType) {
      @case ('notImplemented') {
        <button mat-stroked-button color="primary" [disabled]="vm.noPaginationData" class="text-nowrap">
          <ng-container *ngTemplateOutlet="inactiveFilterButtonContents"/>
        </button>
      }
      @case ('dateRange') {
        <button mat-stroked-button color="primary" (click)="onClickDateRangeButton()" [disabled]="vm.noPaginationData" class="text-nowrap">
          <ng-container *ngTemplateOutlet="inactiveFilterButtonContents"/>
        </button>
      }
      @default {
        <!-- 'singleSelect' or 'multiSelect' -->
        <span [matTooltip]="vm.noPaginationData || vm.filterOptions.length === 0 ? 'No filter options available' : ''">
          <button mat-stroked-button color="primary" [matMenuTriggerFor]="filterMenu" class="text-nowrap"
                  [disabled]="vm.noPaginationData || vm.filterOptions.length === 0">
            <ng-container *ngTemplateOutlet="inactiveFilterButtonContents"/>
          </button>
        </span>
      }
    }
  }

  <ng-template #inactiveFilterButtonContents>
    {{ inactiveButtonLabel }}
    <mat-icon class="mat-icon-size-4.5 text-on-surface-variant -me-2 -mb-[0.1875rem]">keyboard_arrow_down</mat-icon>
  </ng-template>

  <mat-menu #filterMenu="matMenu" (closed)="onClosedOptionsMenu()" class="mx-table-card-header-filter-menu-panel">
    <ng-template matMenuContent let-showHeader="showHeader">
      @if (showHeader) {
        <header class="px-2 text-title-medium text-on-surface">{{ inactiveButtonLabel | mxTitleCase }}</header>
      }

      @if (filterOptionsSelector) {
        @for (filterOption of vm.filterOptions; track filterOption.value) {
          <button mat-menu-item (click)="onClickMenuOption($event, filterOption)">
            @if (isMultiSelect) {
              <mat-checkbox color="primary" [checked]="isSelected(filterOption)">
                <ng-container *ngTemplateOutlet="filterOptionAndCount; context: {
                  name: filterOption.displayName, count: filterOption.count, cssClasses: 'text-body-large ms-1'
                }"/>
              </mat-checkbox>
            } @else {
              <ng-container *ngTemplateOutlet="filterOptionAndCount; context: {
                name: filterOption.displayName, count: filterOption.count
              }"/>
            }
          </button>
        }
      }
    </ng-template>
  </mat-menu>

  <ng-template #filterOptionAndCount let-name="name" let-count="count" let-cssClasses="cssClasses">
    <span [class]="cssClasses">
      {{ name }}

      @if (count) {
        ({{ count | format:'NUMBER' }})
      }
    </span>
  </ng-template>

  @if (showDateRangePicker) {
    <div class="absolute w-[22.5rem]">
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="dateRangeStart">
        <input matEndDate [(ngModel)]="dateRangeEnd">
      </mat-date-range-input>

      <mat-date-range-picker #picker (closed)="onClosedDatePicker()">
        <mat-datepicker-actions>
          <button mat-button color="primary" matDatepickerCancel (click)="onClickDateRangeCancelButton()">Cancel</button>
          <button mat-button color="primary" matDatepickerApply (click)="onClickDateRangeApplyButton()">OK</button>
        </mat-datepicker-actions>
      </mat-date-range-picker>
    </div>
  }
}
